export default "__VITE_ASSET__CMb_SgUh__"